export const SidebarLabelConstant = {
  dashboard: 'Dashboard',
  logout: 'Logout',
  userManagement: 'User Management',
  notification: 'Notification',
};

export const UnderMainatanceLabelConstant = {
  title: 'Sorry!! We are under maintenance',
  titleDevelopement: 'Sorry!! We are under Developement',
  mainParagraph:
    'Our website is currently undergoing some upgrades, we will be up and running soon.',
  paragraph: 'Thank you for your patience.',
};

export const CommonFileUploadConstant = {
  DocumentStorage: 'Document Storage',
  DropFile: 'Drop Your Image or',
  Browse: 'Browse',
  Here: 'here.....',
  Supports: 'Supports : ',
  UploadFormat: 'Office Docs, PDF, Images',
  List: 'Uploaded Document List',
  Info: 'info',
  Documents: 'Documents',
};

export const commonLabelConstants = {
  ChangeStatus: 'Change Status',
  AreYouSure: 'Are you sure you want to',
  Yes: 'Yes',
  No: 'No Thanks',
  Logout: 'Logout',
  Cancel: 'Cancel',
  Delete: 'Delete',
  UnsavedChanges:
    'Are you sure you want to leave this page? You have unsaved changes.',
  CopyRight: 'Copyright',
  Rights: 'All rights reserved.',
  MyAccount: 'My Account',
  OK: 'Ok',
  youAreUnable: 'You are unable to',
  delete: 'delete',
  youCan: 'You can',
  goBack: 'Go Back',
  dirtyCheck: 'Confirmation',
  Dirtycheckconfirmation:
    'Are you sure you want to leave this page? You have unsaved changes.',
  NoReacordFound: 'No record found',
  Forms: 'Forms',
  Save: 'Save',
  Locked: '(Locked)',
  ViewPermission: 'View permission only.',
};

export const LoginLabelConstants = {
  Email: 'Email',
  ForgotPass: 'Forgot Password?',
  Login: 'Login',
  Password: 'Password',
};

export const ForgotPassLabelConstants = {
  BackToLogin: 'Back To Login',
  Email: 'Email',
  ForgotPassword: 'Forgot Password',
  GoBack: 'GO TO BACK',
  ResetPassword: 'Set Password',
  SendLink: 'Send Reset Link On Email',
};

export const ResetPassLabelConstants = {
  ConfirmPassword: 'Confirm Password',
  GoBack: 'GO TO BACK',
  NewPassword: 'New Password',
  Password: 'Password',
  ResetPassword: 'Set Password',
  expiredLink: 'This link is expired. please resend link to reset password',
  CurrentPassword: 'Current Password',
  BackToLogin: 'Back To Login',
  ChangePassword: 'Change Password',
};

export const UserLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  AddNew: 'Add New',
  Address: 'Address',
  Cancel: 'Cancel',
  City: 'City',
  Country: 'Country',
  Email: 'Email',
  FirstName: 'First Name',
  Filter: 'Filter',
  Image: 'Image',
  LastName: 'Last Name',
  NameOfRole: 'Name Of Role',
  NoRecordFound: 'No any user record found!',
  PhoneNumber: 'Phone Number',
  PostalCode: 'Postal Code',
  Role: 'Role',
  State: 'State',
  Update: 'Update',
  UserManagement: 'User Management',
  UserPreview: 'User Preview',
  AddUser: 'Add User',
  EditUser: 'Edit User',
  Status: 'Status',
  resendPasswordLink: 'Resend Password Link',
  Active: 'Active',
  InActive: 'InActive',
  FilterUserRole: 'Select Role',
  FilterUserStatus: 'Select Status',
  clearall: 'Clear all',
  applyall: 'Apply',
  InValidData: 'Select proper data for apply filter',
  UserName: 'User Name',
  UserEmail: 'User Email',
  CountryCode: 'CountryCode',
  MobileNumber: 'MobileNumber',
  Gender: 'Gender',
  ExportToExcel: 'Export Excel',
  Male: 'Male',
  Female: 'Female',
  Other: 'Other',
  Company: 'Company',
  Profile: 'Profile',
  UserList: 'User List',
  JobRole: 'Job Role',
  CompanyName: 'Company Name',
  ChangeStatus: 'Change Status',
  ResendPasswordLink: 'Resend Password Link',
  MyProflle: 'My Profile',
  ProfilePicture: 'Profile Picture',
  ViewUser: 'View User',
};

export const StaffLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  AddNew: 'Add New',
  Address: 'Address',
  Cancel: 'Cancel',
  City: 'City',
  Country: 'Country',
  Email: 'Email',
  FirstName: 'First Name',
  Filter: 'Filter',
  Image: 'Image',
  LastName: 'Last Name',
  NameOfRole: 'Name Of Role',
  NoRecordFound: 'No any user record found!',
  PhoneNumber: 'Phone Number',
  PostalCode: 'Postal Code',
  Role: 'Role',
  State: 'State',
  Update: 'Update',
  UserManagement: 'User Management',
  UserPreview: 'User Preview',
  AddUser: 'Add User',
  EditUser: 'Edit User',
  Status: 'Status',
  Active: 'Active',
  InActive: 'InActive',
  FilterUserRole: 'Select Role',
  FilterUserStatus: 'Select Status',
  clearall: 'Clear all',
  applyall: 'Apply',
  InValidData: 'Select proper data for apply filter',
  UserName: 'UserName',
  UserEmail: 'UserEmail',
  CountryCode: 'CountryCode',
  MobileNumber: 'MobileNumber',
  Gender: 'Gender',
  ExportToExcel: 'Export Excel',
  Male: 'Male',
  Female: 'Female',
  Other: 'Other',
};

export const notificationConstants = {
  ContentTitle: 'Content Title',
  Subject: 'Subject',
  Description: 'Description',
  Submit: 'Submit',
  Cancel: 'Cancel',
  Status: 'Status',
  pageHeading: 'Notification',
  searchPlaceholder: 'Search',
  addNewNotification: 'Add New Notification',
  exportToExcel: 'Export to Excel',
  exportToPdf: 'Export to PDF',
  subject: 'Subject',
  content: 'Content',
  actions: 'Actions',
  active: 'Active',
  inactive: 'Inactive',
  noRecordFound: 'No notification record found!',
  editCategory: 'Edit Category',
  deleteCustomer: 'Delete Customer',
  buttonImgAlt: 'Button Icon',
};

export const RoleLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  AddNew: 'Add New',
  Cancel: 'Cancel',
  RoleManagement: 'Role Management',
  RoleName: 'Name of Role',
  NoRecordFound: 'No role records found!',
  Srno: '#',
  TypeRoleName: 'Role Name',
  Update: 'Update',
  HierarchyLevel: 'Hierarchy Level',
  RoleId: 'Role ID',
  RoleList: 'Role List',
  RoleOfRights: 'Roles Of Rights',
  Modules: 'Modules',
  SelectAll: 'Select All',
  IsAdd: 'Add',
  IsView: 'View',
  IsEdit: 'Edit',
  IsDelete: 'Delete',
  UpdateAllRoles: 'Update All Roles',
  EditRole: 'Edit Role',
  AddRole: 'Add Role',
  RolesofRights: 'Roles Of Rights',
};

export const SoftwareLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  Software: 'Software',
  SoftwarePreview: 'Software Preview',
  AddSoftware: 'Add Software',
  EditSoftware: 'Edit Software',
  DescriptionOfLicence: 'Description of licence',
  ProjectName: 'Project Name',
  CompanyName: 'Company Name',
  SoftwareVersion: 'Software Version',
  SoftwareManufacturer: 'Software Manufacturer',
  PayCurrency: 'Pay Currency',
  USDExchangeRate: 'USD Exchange Rate',
  Cost: 'Cost (£)',
  LicenceKey: 'Licence Key',
  SoftwarePurchaseDate: 'Software Purchase Date',
  SoftwareExpieryDate: 'Software Expiery Date',
  UseStartDate: 'Use Start Date',
  UseEndDate: 'Use End Date',
  SoftwareNote: 'Software Note',
  Update: 'Update',
  downloadTemplate: 'Download Template',
  NoOfLicence: 'No of Licence',
  ViewSoftware: 'View Software licence',
  SoftwareList: 'Software List',
  Viewsoftware: 'View Software',
  Id:'Id'
};

export const ConsumableLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Update: 'Update',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  ConsumableItems: 'Consumable Items',
  ConsumableItemsPreview: 'Preview Consumable Items',
  AddConsumableItems: 'Add Other Consumable Item ',
  EditConsumableItems: 'Edit Other Consumable Item ',
  ConsumableItemsName: 'Item description',
  BriefDescriptionCost: 'Brief description of purpose',
  ProjectName: 'Project Name',
  CompanyName: 'Company Name',
  ConsumableItemsCost: 'Cost (£)',
  FinicialYearStartDate: 'Finicial Year Start Date',
  FinicialYearEndDate: 'Finicial Year End Date',
  ListAddNew: 'New',
  ConsumableListItem: 'Consumable Items List',
  OtherConsumableItems: 'Other Consumable Item',
};

export const PaymentToClinicalTrialLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Update: 'Update',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  PaymentsToClinicalTrial: 'Payments To Clinical Trial Participants',
  AddPaymentsToClinicalTrial: 'Add Payments To Clinical Trial Participants ',
  EditPaymentsToClinicalTrial: 'Edit Payments To Clinical Trial Participants ',
  ParticipantName: 'Participant name',
  BriefDescriptionCost: 'Brief description of purpose',
  ProjectName: 'Project Name',
  CompanyName: 'Company Name',
  PaymentsToClinicalTrialCost: 'Cost (£)',
  ListAddNew: 'New',
  PaymentsToClinicalTrialItem: 'Payments To Clinical Trial Item List',
};

export const UtilityLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Update: 'Update',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  Utility: 'Utility',
  UtilityPreview: 'Utility Preview',
  AddUtility: 'Add Water, Fuel and Power',
  EditUtility: 'Edit Water, Fuel and Power',
  UtilityName: 'Utility name',
  ProjectName: 'Project Name',
  CompanyName: 'Company Name',
  UtilityCost: 'Utility Cost (£)',
  FinicialYearStartDate: 'Finicial Year Start Date',
  FinicialYearEndDate: 'Finicial Year End Date',
  AnnualCost: 'Annual cost (£)',
  utilityText: 'Water, Fuel and Power',
  UtilityList: 'Water, Fuel and Power List',
};

export const DataLicenceLabelConstants = {
  Licence: 'Licence',
  LicencePreview: 'Licence Preview',
  AddLicence: 'Add Data Licence',
  EditLicence: 'Edit Data Licence',
  LicenceName: 'Data licence description',
  ProjectName: 'Project Name',
  CompanyName: 'Company Name',
  LicenceVersion: 'Licence Version',
  PayCurrency: 'Pay Currency',
  USDExchangeRate: 'USD Exchange Rate',
  Cost: 'Cost (£)',
  UniqueId: 'Id',
  LicenceKey: 'Licence Key',
  DataLicencePurchaseDate: 'Data Licence Purchase Date',
  DataLicenceExpieryDate: 'Data Licence Expiery Date',
  UseStartDate: 'Use Start Date',
  UseEndDate: 'Use End Date',
  Update: 'Update',
  Add: 'Add',
  NoOfLicence: 'No of Licence',
  DataLicence: 'Data Licences',
  DataLicenceList: 'Data Licences List',
};

export const CloudComputingLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  CloudComputingCosts: 'Description of cloud computing costs',
  ProjectName: 'Project Name',
  PayCurrency: 'Pay Currency',
  USDExchangeRate: 'USD Exchange Rate',
  Cost: 'Cost (£)',
  UseStartDate: 'Use Start Date',
  UseEndDate: 'Use End Date',
  Update: 'Update',
  CloudComputing: 'Cloud Computing',
  CloudComputingList: 'Cloud Computing List',
  AddCloudComputing: 'Add Cloud Computing',
  EditCloudComputing: 'Edit Cloud Computing',
  Id:'Id'
};

export const EPWConnectedCostLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  Salary: 'Salary',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  Update: 'Update',
  Name: 'Contractor name',
  Activities: 'DescriptionOfActivities',
  ExternalCost: 'External Cost',
  ConsumableCost: 'Consumable Cost',
  DataLicenceCost: 'Data Licence Cost',
  ComputingCost: 'Computing Cost',
  ClinicaltrialCost: 'Clinical Trial Cost',
  TotalCost: 'Total Cost',
  Cost: 'Cost',
  Description: 'Description',
  JobRole: 'Job role on the project',
  StaffProvider: 'Staff provider',
  PAYESchemeReferenceToStaffProvider: 'Employer PAYE reference for EPW',
  PaymentsMadeToTheStaffProviderForNonUK:
    'Payments made to the staff provider for non-UK work (£)',
  PaymentsMadeToTheStaffProviderForUK:
    'Payments made to the staff provider for UK work (£)',
  Project: 'Project',
  Company: 'Company',
  AddEPWUnConnectedCost: 'Add Externally Provided Workers - Unconnected',
  EditEPWUnConnectedCost: 'Edit Externally Provided Workers - Unconnected',
  EPWUnconecteCost: 'Externally Provided Workers - Unconnected',
  EPWUnconnetedCostList: 'Externally Provided Workers - Unconnected List',
  Id:'Id'
};

export const ProjectLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  ProjectName: 'Project name',
  Description: 'Project description',
  ProjectStartDate: 'R&D start date',
  ProjectEndDate: 'R&D end date',
  TotalQualifyingCostClaimed: 'Total qualifying cost claimed  (£)',
  ProjectQualifyingCostTotalProjectCost:
    'Project qualifying cost as a proportion of total qualifying cost (%)',
  CumulativeNextProjectCost: 'Cummulative %',
  IsCumulativeCostAbove50Percent:
    'Will further details of this project be provided to HMRC?',
  CompanyName: 'Company Name',
  Update: 'Update',
  ProjectList: 'R&D Projects Record List',
  ProjectManagement: 'R&D Projects Record',
  AddProject: 'Add Project',
  EditProject: 'Edit Project',
};

export const EmployeeLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  CTC: 'CTC',
  IsContractor: 'IsContractor',
  IsEPW: 'Is EPW',
  Update: 'Update',
  Name: 'Employee name',
  EmployeeRole: 'Employee role',
  JobRole: 'Job role on the project',
  StartDate: 'Start date',
  EndDate: 'End date',
  BasicPay: 'Basic pay (£)',
  CashAllowances: 'Cash allowances (£)',
  CashBonuses: 'Cash bonuses (£)',
  NationalInsurances: 'Employer contributions to national insurance (£)',
  Pension: 'Employer contributions to pension (£)',
  TotalGrossPay: 'Total gross pay (Before any deductions) (£)',
  TotalGrossPayShort: 'Total gross pay (£)',
  StaffingCostList: 'Staffing',
  StaffingCostListTemplate: 'Staffing Template',
  StafingCost: 'Staffing',
  AddStaffingCost: 'Add Staffing',
  EditStaffingCost: 'Edit Staffing',
  Id:'Id'
};

export const EmployeePayLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  BasicPay: 'Basic Pay',
  Cashbonus: 'Cashbonus',
  NICS: 'NICS',
  CNI: 'CNI',
  CNP: 'CNP',
  EPS: 'EPS',
  Gross: 'Gross',
  Update: 'Update',
};

export const CompanyLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  CompanyName: 'Company Name',
  VATNo: 'VAT Number',
  SICCode: 'SIC Code',
  CompanyEmail: 'Company Email',
  Address: 'Address',
  CompanyPhoto: 'Image',
  OfficeTelephoneNo: 'Office Telephone No',
  OfficeMobileNo: 'Office Mobile No',
  Update: 'Update',
  ClaimStartDate: 'Claim Start date',
  ClaimEndDate: 'Claim End Date',
  City: 'City',
  Country: 'Country',
  PostalCode: 'Postal Code',
  State: 'State',
  PayeRef: 'Does the company have a PAYE reference',
  PayeRefNumber: 'Employer PAYE Reference Number',
  VatRef: 'Does the company have a VAT reference',
  VatNumber: 'VAT Number',
  ClaimStatus: 'Claim Status',
  IsLocked: 'Lock Status',
  CompanyList: 'Company List',
  Logo: 'Logo',
  ClaimList: 'Claim List',
  Status: 'Lock/Unlock',
  ChangeStatus: 'Change Status',
  Company: 'Company',
  dirtyCheck: 'Confirmation',
  Dirtycheckconfirmation:
    'Are you sure you want to leave this page? You have unsaved changes.',
};

export const RoleErrorMessages = {
  RoleNameRequired: 'Role name is required.',
  RoleHierarchyLevelRequired: 'Hierarchy level is required.',
  RoleHierarchyLevelInValid: 'Invalid hierarchy level',
  ErrorFatchingRole: 'Error fetching roles',
  HierarchyCantZero: `Hierarchy Level can't be zero`,
};

export const EPWConnectedPartyLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  PersonName: 'Personnel name',
  ProjectName: 'Project name',
  JobRole: 'Job role on the project',
  BasicPay: 'Basic pay (£)',
  CashAllowances: 'Cash allowance (£)',
  CashBonuses: 'Bonuses (£)',
  ContributionToNationalInsurance:
    'Employer contributions to national insurance (£)',
  Pension: 'Employer contributions to pension (£)',
  TotalGrossPay: 'Total gross pay (Before any deductions) (£)',
  Update: 'Update',
  NameOfConnectedParties: 'Name of connected party/staff provider',
  PayeSchema: 'PAYE scheme reference of connected party',
  ConnectedParties: 'Externally Provided Workers - Connected',
  EpwConnectedPartiesList: 'Externally Provided Workers - Connected List',
  AddEpwConnectedParties: 'Add Externally Provided Workers - Connected',
  EditEpwConnectedParties: 'Edit Externally Provided Workers - Connected',
  Country: 'Country in which EPW work was undertaken',
  TotalGrossPayForUk: 'Total gross pay (Before any deductions) UK costs (£)',
  TotalGrossPayForNonUk:
    'Total gross pay (Before any deductions) non-UK costs (£)',
    HeaderTotalGrossPayForUk: 'Total gross pay UK costs (£)',
  HeaderTotalGrossPayForNonUk:'Total gross pay non-UK costs (£)',
  Id:'Id'
};

export const NotificationLabelConstants = {
  Notification: 'Notifications',
  ClearAll: 'Clear All',
};

export const ClientLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  AddNew: 'Add New',
  Address: 'Address',
  Cancel: 'Cancel',
  City: 'City',
  Country: 'Country',
  Email: 'Email',
  CompanyName: 'Company Name',
  ClientName: 'Client Name',
  ContactNumber: 'Contact Number',
  PostalCode: 'Postal Code',
  State: 'State',
  Update: 'Update',
  AddClient: 'Add Client',
  EditClient: 'Edit Client',
  Status: 'Status',
  ClaimType: 'Claim Type',
  FirstName: 'First Name',
  LastName: 'Last Name',
};

export const CompanyInfoConstants = {
  CompanyInfo: 'Company Information & Financials',
  CompanyDetail: 'Company Details',
  BusinessName: 'Business Name',
  TaxUniqueRef: 'Corporation Tax Unique Tax Payer Reference',
  PayeRef: 'Does the company have a PAYE reference',
  PayeRefNumber: 'Employer PAYE Reference Number',
  VatRef: 'Does the company have a VAT reference',
  VatNumber: 'VAT Number',
  Businesstype: 'Business type/SIC code',
  ContactAgentDetail: 'Contact And Agent Details',
  AgentContactDetail: 'Agent contact details',
  AgentFullName: 'Full Name',
  AgentEmail: 'Email to send confirmation to',
  AgentBusinessName: 'Agent Business Name',
  AgentTelNumber: 'Telephone',
  AgentUkAddress: 'UK Address',
  AgentBusinessAddress: 'Registered Business Address',
  TypeOfAgent: 'Type of Agent',
  OtherAgent: 'Any Other Agent',
  OtherAgentFullName: 'Other Agent’s Full Name',
  OtherAgentBusinessName: 'Other Agent’s Business Name',
  OtherAgentTelNumber: 'Telephone Number For Other Agent',
  OtherAgentEmail: 'Email Address For Other Agent',
  OtherAgentUkAddress: 'Other Agent UK Address',
  DetailOfSeniorOfficer: 'Details of senior officer at the claimant company',
  SeniorOfficerFullName: 'Senior Officer’s Full Name',
  SeniorOfficerRole: 'Senior Officer’s Role',
  SeniorOfficerTelNumber: 'Telephone Number For Senior Officer',
  SeniorOfficerEmail: 'Email Address For Senior Officer',
  AccountingPeriod: 'Accounting periods',
  AccountingStartDate: 'Accounting Period Start Date',
  AccountingEndDate: 'Accounting Period End Date',
  IsAccountingPeriod:
    'Is the accounting period part of a long period of account?',
  Schemes: 'Schemes',
  PayableForAllStaff: 'Total PAYE payable for all staff',
  DetailsOfPAYEAndNIPayableForAllStaff : 'Total PAYE/NI payable for all staff',
  TotalNIPayableForAllStaff: 'Total NI Payable for all staff',
  OtherFinancialData: 'Other financial data',
  CompanyTurnOver: 'Company turnover for the period',
  TotalStaffCost: 'Total company staff costs',
  TotalStaffCostDetail: '(Including employer NI and Pension contributions)',
  CorporationTaxRate: 'Corporate tax rate',
  AccountingPeriods:
    'Corporation tax rate for the period to 1 April of the accounting period',
  PostAccountingPeriod:
    'Corporation tax rate for the period post 1 April of the accounting period',
  ClaimCost: 'Which costs will the company be claiming',
  Staff: 'Staff',
  UnConnectedContractor:
    'Externally Provided Workers - Unconnected',
  GroupOfContractor:
    'Externally Provided Workers - Connected',
  UnConnectedContractorRD: 'Contracted out R&D - Unconnected',
  ConnectedContractorRD: 'Contracted out R&D - Connected',
  SoftwareLicences: 'Software',
  DataLicences: 'Data licences',
  CloudComputing: 'Cloud computing services',
  ConsumableItemsExcludingUtilities: 'Consumable Items Excluding Utilities',
  Utilities: 'Utilities',
  PaymentsToClinicalTrialParticipants:
    'Payments to Clinical trial participants',
  EmployerPAYEReferenceNumberRequired:
    'Employer PAYE reference number required.',
  Save: 'Save',
  InfoForForm: 'Information from the company tax computation for the year',
  TaxableProfitLoss: 'Taxable profit/loss before R&D',
  TotalPlExpenditure: 'Trading and Operating Expenditure',
  TotalExpenditureCTA: 'Total expenditure claimed under s1308 CTA 2009',
  TotalNonTaxExpenditure: 'Total non-tax deductible expenditure',
  CorporateTaxRate: 'Applicable corporation tax rate',
  ExpenditureCreditRate: 'R&D Expenditure Credit rate',
  IntensiveSupportSchema: 'Enhanced deduction under Enhanced R&D Intensive Support (ERIS)',
  OtherMandatoryInfo: 'Other Mandatory information',
  VATNumberRequired: 'VAT number required.',
  BusinessTypeSICCodeRequired: 'Business type/SIC code is required.',
  EnhancedIntensiveSupport: 'Enhanced R&D Intensive Support (ERIS)',
};

export const OtherMandatoryInfoConstants = {
  InfoForForm: 'Information from the company tax computation for the year',
  TaxableProfitLoss: 'Taxable profit/loss before R&D',
  TotalPlExpenditure: 'Trading and Operating Expenditure',
  TotalExpenditureCTA: 'Total expenditure claimed under s1308 CTA 2009',
  TotalNonTaxExpenditure: 'Total non-tax deductible expenditure',
  CorporateTaxRate: 'Applicable corporation tax rate',
  ExpenditureCreditRate: 'R&D Expenditure Credit rate',
  IntensiveSupportSchema: 'Enhanced deduction under Enhanced R&D Intensive Support (ERIS)',
  OtherMandatoryInfo: 'Other Mandatory information',
  Save: 'Save',
};

export const completionChecklist = {
  Heading: 'COMPLETION CHECKLIST',
  No: 'No',
  Action: 'Action',
  Description: 'Description',
  ConfirmedNa: 'Confirmation',
  Remarks: 'Remarks',
  Claim: 'Initial of Senior Official Signing off the Claim',
  NoDataAvaliable: 'No data available.',
};

export const PayCapForm = {
  HeaderText: 'Cash Credit Cap Calculation',
  ForStaff: 'FOR STAFF',
  Description: 'Description',
  TotalPayDetail:
    'Total of PAYE payable by the company for all its workers whether or not involved in R&D',
  TotalOfClassDetail:
    'Total Class 1 NI contributions (Employee and Employer) payable by the company for all its workers',
  ConnectedParty: 'FOR CONNECTED PARTY EPW',
  TotalPayPayableDetail: `Total PAYE payable by the company for connected party EPW (such as group personnel) involved in R&D activities MULTIPLIED BY the R&D eligibility percentage of these personnel.`,
  TotalNIClassDetail: `Total NI (Employer and Employee contributions) payable by the company for connected party EPW (such as group personnel) involved in R&D activities MULTIPLIED BY the R&D eligibility percentage of these personnel.`,
  PayeNiConnectedParty: 'PAYE/NI ON CONNECTED PARTY SUBCONTRACT R&D ACTIVITIES',
  TotalPayStaffingCost:
    'Total PAYE on staffing costs incurred by the connected company in performing the R&D activities.',
  TotalNIClass1Detail:
    'Total NI Class 1 (employee and employer) costs incurred by the connected company in performing the R&D activities.',
  TotalOfAllCost: 'Total of all above costs',
  Multiplier: 'Multiplier',
  AddAccountingPeriod:
    ' Add: £20,000 (apportioned for the length of the accounting period)',
  TotalCap: 'Total cap',
  Submit: 'Submit',
  ExemptionOfPaycap: 'Exemption from the PAYE/NI Cap',
  DetailOfExemption: `Note that if the figure for the Total Cap is very low, for example, where a large proportion of the company's claim relates to unconnected subcontracted activities, check if you qualify for an exemption from the Cap.`,
  IsCompanyexemption: 'Is the company exempt from the PAYE/NI Cap?',
  IfYesDetail: `If the answer above is YES, please provide details below.`,
  PayCapForm: 'Paycap Form',
  PAYECapCalculation: 'Cash Credit Cap Calculation',
};

export const SubContractorUnconnectedLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  Update: 'Update',
  Name: 'Subcontractor name',
  Description:
    'Description of activities',
  CompanyRegistrationNumber: 'Company registration number',
  Cost: 'Cost (£)',
  SubContractorUnconnected: 'Contracted Out R&D - Unconnected',
  subContractorUnconnectedList: 'Contracted Out R&D - Unconnected List',
  AddSubContractorUnconnected: 'Add Contracted Out R&D - Unconnected',
  EditSubContractorUnconnected: 'Edit Contracted Out R&D - Unconnected',
  Id:'Id'
};

export const SubContractorConnectedPaeriesLabelConstants = {
  Actions: 'Actions',
  Add: 'Add',
  Cancel: 'Cancel',
  AddNew: 'Add New',
  Update: 'Update',
  Name: 'Connected party subcontractor name',
  Description: 'Description of activities undertaken',
  ExternallyProvider: 'Externally provided workers (£)',
  Cost: 'Staffing Costs (£)',
  ConsumableItem: 'Consumable Items (£)',
  RowCost: 'Software, Data Licences, Cloud Computing (£)',
  Payments: 'Payment To Subjects Of Clinical Trials (£)',
  Total: 'Total (£)',
  SubconConnectedParties: 'Contracted Out R&D - Connected',
  SubconConnectedPartiesList: 'Contracted Out R&D - Connected List',
  AddSubconConnectedParties: 'Add Contracted Out R&D - Connected',
  EditSubconConnectedParties: 'Edit Contracted Out R&D - Connected',
  TotalForUk: 'Total for UK costs (£)',
  TotalForNonUk: 'Total for overseas costs (£)',
  Country: 'Country of registration of subcontractor company',
  TotalForOverseasCost: 'Total for overseas costs (£)',
   Id:'Id'
};

export const ActivityLogLabelConstants = {
  ActivityLogList: 'Activity Log List',
};

export const CommonLabelConstant = {
  Close: 'CLOSE',
  Save: 'SAVE',
  New: 'NEW',
  Update: 'UPDATE',
  Tmplate: 'TEMPLATE',
  Import: 'IMPORT',
  SubconCountry: 'Country of registration of subcontractor company',
  Preview: 'Preview',
  Locked: '(Locked)',
  ViewPermission: 'View permission only.',
};
export const staffingCostByProject = {
  StaffingCostHeader: 'Staffing',
  EmployeeName: 'Employee Name',
  JobRole: 'Job Role',
  EligibleCost: 'Eligible staffing costs (£)',
  Cost: 'Total Qualifying Costs (£)',
  Staffing: 'Staffing',
};
export const EpwCostsByProject = {
  EpwCostByProjectHeader: 'Externally Provided Workers - Unconnected',
  ContractorName: 'Contractor Name',
  JobRole: 'Job Role On Project',
  Cost: 'Cost (£)',
  TotalEligibleCost: 'Total Eligible costs at 65%',
  ExternallyProviderWorker: 'Externally Provided Workers-Unconnected',
  TotalQualifyingCostsUK: 'Total Qualifying Costs at 65% UK',
  TotalQualifyingCostsNonUK: 'Total Qualifying Costs at 65% Non-UK',
  CostForUKWork: 'Cost For UK Work (£)',
  CostForNonUKWork: 'Cost For Non-UK Work (£)',
};

export const CloudComputingProject = {
  CloudComputingHeader: 'Cloud Computing',
  Details: 'Details Of Costs Incurred',
  Cost: 'Costs (£)',
  Total: 'Total Qualifying Costs (£)',
  CloudComputingService: 'Cloud Computing Services',
};

export const DataLicenceProject = {
  DataLicenceHeader: 'Data licences',
  Description: 'Data Licence Description',
  Cost: 'Cost (£)',
  Total: 'Total Qualifying Costs (£)',
  DataLicences: 'Data licences',
};

export const MaterialConsumableProject = {
  MatrialAndConsumableHeader: 'Consumable Items',
  Details: 'Details',
  Cost: 'Cost £',
  Total: 'Total (£)',
  ConsumableItem: 'Consumable Items Excl Utilities',
};
export const PaymentsToClinicalTrial = {
  PaymentsToClinicalTrial: 'Payments To Clinical Trial Participants',
  PaymentsToClinicalTrialTotal: 'Total Payments To Clinical Trial Participants',
  Details: 'Details1',
  Cost: 'Cost £',
  Total: 'Total (£)',
  ConsumableItem: 'Payments To Clinical Trial Participants',
};
export const SoftwareByProject = {
  SoftwareByProjectHeader: 'Software',
  SoftwareName: 'Software Licence Name',
  Cost: 'Cost (£)',
  Total: 'Total (£)',
  Software: 'Software',
};

export const SubContractorUnconnectedProject = {
  SubContractorUnconnectedHeader: 'Contracted Out R&D - Unconnected',
  ContractorName: 'Contractor Name',
  Description: 'Description Of Activities Undertaken',
  Cost: 'Cost (£)',
  Total: 'Total Qualifying Costs (£)',
  ContractorOut: 'Contracted out R&D',
  TotalQualifyingCosts65NonUK: 'Total qualifying costs at 65% UK (£)',
  TotalQualifyingcostsat65NonUK: 'Total Qualifying costs at 65% Non-UK (£)',
  CostForUKWork: 'Cost for UK work (£)',
  CostForNonUKWork: 'Cost for non-UK work (£)',
};

export const UtilityFormConstants = {
  Forms: 'Forms',
  WaterFuelAndPower: 'Water, Fuel And Power',
  TotalCosts: 'Total Costs',
  BusinessAverage: 'Business Average %',
  QualifyingCosts: 'Qualifying Costs',
  TotalQualifyingCosts: 'Total Qualifying Costs',
  UtilityCosts: 'Utility Costs',
  Utilities: 'Utilities',
};

export const RndIntensityConstants = {
  RndIntensityHeader: 'R&D Intensity Calculation',
  Description: 'Description',
  Value: 'Value',
  HasLossBeforeTax:
    'Has the company made a loss before tax for the accounting period?',
    TotalQualifyingRDExpenditure: 'Total qualifying R&D expenditure',
    RelevantRNDExpenditure: 'Relevant R&D Expenditure',
  ConnectedCompanyRDExpenditure:
    'Total qualifying R&D expenditure of any connected companies',
    TotalRelevantExpenditure: `Total Relevant Expenditure:`,
  TotaltaxDeduction: `Total Relevant R&D Expenditure`,
  ProportionRelevantRNDexpenditure: `Proportion of Relevant R&D expenditure over Total Relevant expenditure`,
  TotalplExpeniture: '(i) Total Trading and Operating Expenditure',
  Cliamunders1308:
    '(ii) Total adjustment made for capitalised expenditure (Total expenditure claimed under s1308 CTA 2009)',
  TranseferValueConnectedCompany:
    '(iii) Total trading and operating expenses of any companies connected with you  (expenditure per their P&L statements)',
  NonDeductible:
    '(iv) Total expenditure of companies connected with you that has been claimed under s1308 CTA 2009 (adjustment for capitalised R&D expenditure)',
  ProportionofQualifying:
    'Proportion of Qualifying R&D expenditure over total Relevant Expenditure',
  RDIntensityCompany: ' R&D intensive company',
};

export const BenefitSummaryERIS = {
  BenefitSummaryHeader: 'Benefit Summary - ERIS',
  BenefitSummaryFullHeader:
    'Benefit under Enhanced R&D Intensive Support Scheme',
  Description: 'Description',
  BenefitSummary: 'Benefit summary (£)',
  TaxableProfitLossBeforeRND: 'Taxable Profit/ (loss) before R&D',
  ApplicableCorporationTaxRate: 'Applicable CT Rate',
  CorporationTaxLiabilityBeforeRND: 'Corporation Tax Liability before R&D',
  PreRNDClaim: 'Pre- R&D Claim',
  RNDQualifyingExpenditure: 'R&D qualifying expenditure',
  SMEEnhancedDeductionOnEligibleRNDExpenditure:
    'SME enhanced deduction on eligible R&D expenditure',
  TotalEnhancedDeductionDueToRND: 'Total enhanced Deduction due to R&D',
  ProfitLossPostRNDUplift: 'Profit/ Loss Post R&D Uplift',
  CorporationTaxLiabilityAfterRND: 'Corporation Tax Liability after R&D',
  RNDAdjustment: 'R&D Adjustment',
  TaxCreditForSurrenderingLosses : 'Tax Credit @14.5% for surrendering losses (credit is limited to current year trading loss). ',
  TaxCreditClaimableAfterCap: 'Tax credit claimable after consideration of the cap.',
  BenefitSummaryText: 'Benefit Summary',
};

export const BenifitSummaryMergeScheme = {
  BenifitSummaryMergeSchemeheader: 'Benefit Merged RDEC',
  BenifitSummaryRDEC: 'Benefit Summary - RDEC',
  BenefitSummaryMergedScheme: 'Benefit summary Merged scheme',
  Value: 'Value (£)',
  TaxableProfitBeforeRAndD: 'Taxable Profit/ (loss) before R&D',
  ApplicableCTRate: 'Applicable Corporation Tax Rate',
  CTLiabilityBeforeRAndD: 'Corporation Tax Liability before R&D',
  CTLiability: 'CT liability before R&D',
  RAndDQualifyingExpenditure: 'R&D qualifying expenditure',
  RDECExpenditureCreditRate: 'R&D Expenditure Credit rate',
  RDECExpenditureCreditValue: 'R&D Expenditure Credit value',
  Step1RDECOffset:
    'Step 1 - Amount of RDEC used to discharge corporation tax liability',
  Step1BalanceOfRDEC: 'Balance of RDEC carried forward to step 2',
  GrossRDEC: 'Gross RDEC',
  Step1: 'Step 1',
  Step2WithholdingTaxDeduction: 'Step 2 - Deduct withholding tax',
  Step2BalanceAfterWithholdingTax: 'Balance after step 2',
  Step2: 'Step 2 (Net RDEC)',
  Step3RDECAmountCappedByPAYENI: 'Step 3 - RDEC amount capped by PAYE/NI',
  Step3: 'Step 3 - PAYE/NI cap',
  Step3RDECImpactedByPAYENICap:
    'Step 3 RDEC impacted by PAYE/NI CAP carried forward to be treated as an R&D expenditure credit in the next period',
  Step3BalanceCarriedToStep4: 'Balance carried to Step 4',
  Step4SetOffAgainstCTLiabilitiesOtherPeriod:
    'Step 4 - Set off against CT liabilities for any other accounting period',
  Step4: 'Step 4',
  Step4BalanceCarriedToStep5: 'Balance carried to Step 5',
  Step5SetOffAgainstCTLiabilitiesGroupCompany:
    'Step 5 - Set off against CT Liabilities for another group company',
  Step5: 'Step 5',
  Step5CFWToSetp6: 'Balance carried forward to Step 6',
  Step6SetOffOfAnyOtherLiabilitiesOnThisReturn:
    'Step 6 - Set off of any other liabilities on this return, for example, Bank Levy, controlled foreign company tax, tax on loans to participators.',
  Step6SetOffAgainstOtherTaxLiabilities:
    'Step 6 - Set off against any other tax liabilities of the company',
  Step6: 'Step 6',
  Step7BalancePaidSubjectToGoingConcern:
    'Step 7 -Balance of credit receivable in cash, subject to Going Concern condition being met',
  Step7: 'Step 7 - cash repayment',
};

export const ClaimByProject = {
  ClaimByProjectheader: 'Summary of Claim by Project',
  projectName: 'Cost Category',
  Total: 'Total',
  totalEligibleStaffingCosts: 'Staffing',
  totalEPWUnConnected: 'Externally Provided Workers - Unconnected',
  totalEPWConnected: 'Externally Provided Workers - Connected',
  totalSubContractorUnConnected: 'Contracted Out R&D  - Unconnected',
  totalSubContractorConnected: 'Contracted Out R&D  - Connected',
  totalSoftware: 'Software',
  totalDataLicence: 'Data Licences',
  totalCloudComputing: 'Cloud Computing',
  totalConsumableItem: 'Consumable Items',
  utilityCost: 'Water, Fuel and Power',
  paymentsToClinicalTrialParticipants:
    'Payments To Clinical Trial Participants',
  ProjectAmount: 'Amount of the above that is QIA',
};

export const CT600Extract = {
  CT600ExtractHeader: 'Extract fields of CT600 Return to show R&D entries',
  Description: 'Description',
  Value: '',
  RDQualifyingExpenditure: 'Research and development - Form CT600L',
  TaxReconciliation: 'Tax Reconciliation',
  RNDCredit: 'Research and Development Credit',
  RNDExpenditureSurroundToCompany:
    'Research and Development expenditure credits surrendered to this company',
  Information: 'Information about enhanced expenditure and tax reliefs',
  RndText:
    'Research and Development (R&D) or creative enhanced expenditure and tax reliefs',
  IsClaimBySME:
    'Put an ‘X’ in box 650 if the claim is made by a small or medium-sized enterprise (SME), including a SME subcontractor to a large company',
  IsClaimByLarge:
    'Put an ‘X’ in box 655 if the claim is made by a large company',
  IsRNDClaimNotificationSubmitted:
    'Put an ‘X’ in box 656 to confirm that a R&D claim notification form has been submitted',
  IsAIFSubmitted:
    'Put an ‘X’ in box 657 to confirm that an additional information form has been submitted',
  IsQualifyingForSMERelief: 'R&D expenditure qualifying for SME/R&D intensive SME relief',
  EnhancedRNDExpenditure: 'R&D enhanced expenditure',
  CreativeQualifyingExpenditure:
    'Creative qualifying expenditure and/or additional deduction',
  TotalEnhancedAndCreativeExpenditure:
    'R&D and creative enhanced expenditure',
  SMEEnhancedRNDExpenditureFromSubcontracting:
    'R&D enhanced expenditure of a SME on work subcontracted to it by a large company',
  VaccineResearchExpenditure: 'Vaccine Research Expenditure',
  Repayments: 'Repayments for the period covered by this return',
  PayableRADTaxCredit:
    'Payable Research and Development tax credit',
  PayableRADExpenditureCredit:
    'Payable Research and Development expenditure credit',
  CT600L: 'CT600 Extract',
  ISClaimByRAndDIntensiveSME: 'Put an ‘X’ in box 653 if the claim is made by a R&D intensive SME',
};

export const CT600LMergeConstants = {
  L1: 'L1',
  CompanyName: 'Company Name',
  L2: 'L2',
  PAYEReferenceNumber: 'Tax Reference',
  L3: 'L3',
  AccountingStartDate: 'From Date',
  L4: 'L4',
  AccountingEndDate: 'To Date',
  Description: 'Description',
  Amount: 'Amount',
  Step2RestrictionBroughtForward:
    'L5 Step 2 restriction brought forward from previous accounting periods and/or surrendered from group companies (This should tally to last year’s tax computation (from L130 or L100))',
  CTLiabilityBeforeRAndD: 'L6 Corporation Tax liability',
  Step2BroughtForwardSurrenderedRDEC:
    'L7 Amount of step 2 brought forward and surrendered RDEC used to discharge corporation tax liability',
  Step2BroughtForwardRDECCarriedForward:
    'L8 Amount of step 2 brought forward  RDEC carried forward to next accounting period',
  RemainingCTLiabilityCarriedForward:
    'L9 Remaining corporation Tax Liability carried forward to Step 1',
  SecondHeaderText:
    ' Step 1 – Calculation of Research & Development expenditure credit (RDEC) set against Corporation Tax liability',
  RAndDQualifyingExpenditure:
    'L10 R&D expenditure on which RDEC is claimed in this accounting period',
  RDECExpenditureCreditValue: 'L15 RDEC claim for this accounting period',
  AmountsFromPreviousPeriodTreatedAsRDEC:
    'L20 Step 3 amounts from a previous accounting period treated as RDEC for this accounting period',
  TotalRDECExpenditureCredit: `L25 Total RDEC for the accounting period – total of boxes L15 and L20`,
  TotalRemainingCTLiability: 'L30 Remaining corporation Tax liability',
  IncomeTaxDeducted:
    'L35 Income Tax deducted from profits  (applicable to Corporation Tax liability) (This is the figure on box 515 of the CT600)',
  MaximumAmountAvailableForStep1SetOff: `L40 Maximum amount available for Step 1 set-off – box L30 minus box L35`,
  AmountOfRDECUsedForCT: `L45 Amount of RDEC used to discharge Corporation Tax - copy this figure to box L195`,
  ThirdHeaderText: 'Step 2 – Calculation of notional tax charge',
  Step1BalanceCarriedForwardToStep2:
    'L50 Step 1 balance carried forward to Step 2',
  Step2BalanceAfterWithholdingTax:
    'L55 Corporation Tax charge on RDEC for this accounting period',
  TotalRDECArisingLessCTCharge: `L60 Total RDEC arising in this AP less Corporation Tax charge  on RDEC for this accounting period  – box L15 minus box L55`,
  rdecLessCorpTaxStep1:
    'L62 RDEC arising in this AP less remaining Corporation Tax liability at step 1',
  Step2RestrictionCarryForward: `L65 Step 2 restriction carried forward to next accounting period – copy this figure to box L130`,
  ForthHeaderText:
    'Step 3 – Expenditure on R&D workers’ PAYE and National Insurance Contributions',
  Step2BalanceCarryForward: `L70 Step 2 balance carried forward to Step 3 – box L50 minus box L65`,
  TotalRelevantExpenditureRAndDPAYE:
    'L75 Total relevant expenditure on R&D workers’ PAYE and National Insurance Contributions',
  Step3RestrictionCarryForward: `L80 Step 3 restriction carried forward to next AP – copy this figure to box L145`,
  FiveHeaderText:
    'Step 4 – RDEC to be offset against outstanding Corporation Tax liabilities',
  Step3CarryForwardToStep4: `L85 Step 3 balance carried forward to Step 4 – box L70 minus box L80`,
  AmountUsedForCorporationTax:
    'L90 Amount used to discharge Corporation Tax liability of another accounting period.',
  SixHeaderText: 'Step 5 – Amount surrendered to group member',
  Step4CarryForwardToStep5: `L95 Step 4 balance carried forward to Step 5 – box L85 minus box L90`,
  CreditSurrenderedToGroupMember: `L100 Credit surrendered to group member – copy this figure to box L160`,
  SevenHeaderText:
    'Step 6 – Amount used to discharge other company liabilities',
  Step5CarryForwardToStep6: `L105 Step 5 balance carried forward to Step 6 – box L95 minus box L100`,
  AmountUsedToDischargeLiability:
    'L110 Amount used to discharge other company liability on this Corporation Tax Self Assessment',
  AmountUsedForCompanyLiability:
    'L115 Amount used to discharge any other company liability for example, PAYE or VAT. The figure cannot exceed box L105 minus box L110.',
  TotalUsedToDischargeCompanyLiability: `L120 Total used to discharge other company liability – total of boxes L110 and L115`,
  EightHeaderText:
    'Step 7 – Payable Research & Development expenditure credit (RDEC)',
  AmountsExtinguishedByS104S:
    'L123 Amounts extinguished by s104S (2)(b) CTA 2009 (The Going Concern rules)',
  PayableRDEC: `L125 Payable RDEC – copy this figure to box 880 on the form CT600`,
  NineHeaderText: 'RDEC carried forward',
  PreStep1Restriction: 'L129 Pre-step 1 restriction',
  Step2Restriction: 'L130 Step 2 restriction',
  SurrenderedToGroupCompany: `L135 Surrendered to other group company – copy this figure to box L155`,
  BalanceForwardedToNextAccountingPeriod: `L140 Balance carried foward to next accounting period (AP) – box L130 minus box L135`,
  Step3Restriction: 'L145 Step 3 restriction',
  TotalCarriedForwardToNextAP: `L150 Total carried forward to next AP – total of boxes L140 and L145`,
  TenHeaderText: 'RDEC surrendered',
  Step2RestrictionSurrendered: 'L155 Step 2 restriction surrendered',
  Step5CreditSurrenderedToGroupMember:
    'L160 Step 5 credit surrendered to group member',
  TotalSurrendered: `L165 Total surrendered – total of boxes L155 and L160`,
  EvevenHeaderText: 'Small and medium-sized enterprise (SME) R&D',
  RNDExpenditure: 'L166 R&D expenditure',
  ExceptionAtS1058D: 'L167 Does the exception at s1058D CTA 2009 apply?',
  TotalExpenditureConnectedPersons:
    'L167A Total expenditure on externally provided workers from, and subcontracting to, connected persons',
  PAYENICLiabilityCurrentPeriod:
    'L168 PAYE/NIC’s for which the company is liable in this accounting period',
  EmployerPAYEReference: 'L168A Employer PAYE reference',
  RelevantPAYENICLiabilityConnectedCompanies:
    'L169 Relevant PAYE/NIC’s liability of connected companies',
  ConnectedCompanyPAYEReference:
    'L169A Connected company’s employer PAYE reference',
SMERandDTaxCreditClaimCurrentPeriod: "L170 SME/R&D intensive SME R&D payable tax credit claim for this accounting period",

SMERandDBalancePayableTaxCredit:
  "L175 SME/R&D intensive SME R&D balance payable tax credit set off against other liabilities on this return",

  SMRRandDBalancePayableCredit: `L180 SME/R&D intensive SME R&D balance payable credit – box L170 minus box L175`,
  SMERDECClaimSubcontractedWork:
    'L185 SME RDEC claim from work subcontracted to it by a  large company',
  SMERDECClaimSubsidisedCappedWork:
    'L190 SME RDEC claim for subsidised and capped work',
  TwelveHeaderText:
    'Total R&D set-off against liabilities in this Company Tax Return',
  RDECPreStep1DischargeAmount: 'L194 RDEC pre-step 1 discharge amount',
  RDECStep1DischargeAmount: 'L195 RDEC Step 1 discharge amount',
  RDECStep6DischargeAmountCurrentPeriod:
    'L200 RDEC Step 6 discharge amount for this accounting period',
  SMERandDPayableTaxCreditUsed:
    'L205 SME R&D payable tax credit used to discharge other liabilities on this return',
  TotalBoxesL194ToL205: `L210 Total – total of boxes L194 to L205 – copy this figure to box 530 on the form CT600`,
  CT600lMerge: 'CT600L',
};

export const ClaimDashboardLabelConstants = {
  ClaimDashboard: 'Claim Dashboard',
  ClaimDashboardHeader: 'Summary of qualifying expenditures',
  CostCategory: 'Summary by cost category',
  TotalQualifyingExpenditure: 'Total qualifying expenditure (£)',
  StaffingCost: 'Staffing',
  EPWUnconnected: 'Externally Provided Workers - Unconnected',
  EPWConnected: 'Externally Provided Workers - Connected',
  SubContractorUnconnected: 'Contracted out R&D - Unconnected',
  SubContractorConnected: 'Contracted out R&D - Connected',
  Software: 'Software',
  DataLicence: 'Data Licences',
  CloudComputing: 'Cloud Computing',
  ConsumableItem: 'Consumable Items',
  UtilityCosts: 'Utilities',
  PaymentsToClinicalTrialParticipants:
    'Payments To Clinical Trial Participants',
  Total: 'Total',
  QIAAmount: 'Amount of the above that is QIA (Qualifying indirect activities)',
  SummaryOfRND: 'Summary of R&D benefit',
  BenefirUnderMerge: 'BENEFIT UNDER R&D EXPENDITURE CREDIT SCHEME',
  Description: 'Description',
  Amount: 'Amount (£)',
  GrossBenifit: 'Gross Benefit at 20%',
  GrossBenifitFollows: 'Gross benefit can be utilised as follows:',
  NotionalTaxDeduction: `Notional Tax deduction for use as follows:`,
  NotionalTaxDeduction_i: '(i)  Surrender to fellow group company.',
  NotionalTaxDeduction_ii: `(ii) Recover against future tax liabilities`,
  CreditCarriedForwardAsRDExpenditureNextPeriod:
    'Credit carried forward to be treated as R&D Expenditure Credit in the next period',
  SetOffAgainstCTLiabOtherPeriod:
    'Amount available for set off against CT liabilities for any other accounting period ',
  SetOffAgainstCTLiabGroupCompany:
    'Amount available for set off against CT Liabilities for another group company ',
  SetOffAgainstOtherTaxLiabCompany:
    'Amount available for set off against any other tax liabilities of the company',
  AmountPaidAsCashCredit:
    'Amount paid as cash credit, subject to the company being a going concern',
  BenefirUnderEnhancedRND:
    'BENEFIT UNDER THE ENHANCED R&D INTENSIVE SUPPORT SCHEME',
  BenefitUnderRNDIntensiveScheme:
    'Benefit under the Enhanced R&D Intensive Support Scheme',
  ClaimProportion: 'Claim Benchmark Statistics',
  Percentage: 'Percentage (%)',
  TotalCostAsPercentageOfTurnover:
    'Total qualifying costs as a percentage of Turnover',
  QualifyingStaffingCostProportion:
    'Qualifying staffing costs as a proportion of total company staffing costs',
  CalculationOfTexRate: 'Calculation of tax rate',
  AccountingPeriodStart: 'Accounting Period Start',
  AccountingPeriodEnd: 'Accounting Period End',
  DaysUntilMarch312025: 'Number of days to 31 March 2025',
  RemainingDaysToEndOf12MonthPeriod:
    'Remaining days to end of 12  month accounting period',
  PreApril: 'Pre-April',
  PostApril: 'Post-April',
  PostLongApril: 'Post-April Long Period',
  AmountAbovePreApril:
    'Amount of above expenditure relating  to pre-1 April 2025',
  AmountAbovePostApril:
    'Amount of above expenditure relating  to post-1 April 2025',
};

export const ActivityDialogConstants = {
  Close: 'Close',
  Confirm: 'Confirm',
};

export const CalendarActionDialogConstants = {
  Available: 'Are you sure you available on that day ?',
  Action: 'Action',
  Yes: 'Yes',
  No: 'No',
};

export const ConnectedFormConstants = {
  Forms: 'Forms',
  ExternallyProvidedWorkersConnected: 'Externally Provided Workers - Connected',
  ContractorName: 'Contractor Name',
  JobRole: 'Job Role',
  CostForUk: 'Cost  for UK work (£)',
  CostForNonUk: 'Cost  for non-UK work (£)',
  TotalQualifyingCostsForUk: 'Total Qualifying costs UK(£)',
  TotalQualifyingCostsForNonUk: 'Total Qualifying costs  Non-UK(£)',
  ExternallyProvidedWorkersConnectedParties:
    'Externally Provided Workers - Connected Parties (£)',
  ContractedOutConnected: 'Contracted Out R&D - Connected',
  DescriptionOfActivitiesUndertaken: 'Description Of Activities Undertaken',
  SubcontractorsConnectedParties: 'Subcontractors - Connected parties (£)',
};

export const AIFProjectDescriptionConstants = {
  RNDProjectRecord: 'R&D Project Record',
  AIFProjectDescription: 'AIF Project Description',
  ClaimWorkflow: 'Claim Workflow',
  ProjectName: 'Project Name',
  RNDStartDate: 'R&D Start Date',
  RNDEndDate: 'R&D End Date',
  Question: 'Question',
  Previous: 'Previous',
  Save: 'Save',
  Next: 'Next',
  DeleteAnswer: 'Delete Answer',
  AreYouSureDeleteAnswer: 'Are you sure you want to delete this answer?',
};

export const NotesLabelConstants ={
  Date:'Date',
  CompanyName:'Company Name',
  Subject:'Subject',
  Notes:'Notes',
  CreatedBy:'Created By',
  Status:'Status',
  Action:'Action',
  ClaimDate:'Claim Year'
}

export const NoteLabelConstants = {
  editNote: 'Edit Note',
  addNote: 'Add Note',
  selectCompany: 'Select Company',
  selectClaimYear: 'Select Claim Year',
  subject: 'Subject',
  enterSubject: 'Enter Subject',
  description: 'Description',
  enterDescription: 'Enter Description',
  status: 'Status',
  selectStatus: 'Select a Status',
  attachment: 'Attachment',
  download: 'Download',
  delete: 'Delete',
  close: 'Close',
  save: 'Save',
  noUsersFound: 'No Users Found',
  superAdmin: 'Super Admin',
  clientAdmin: 'Client Admin',
  changeStatus:'Change Status',
  replyNote: 'Reply Note',
  date: 'Date',
  descriptionNote: 'Description Note',
  createdBy: 'Created By',
  attached: 'Attached',
  viewIcon: 'View Icon',
  downloadIcon: 'Download Icon',
  notesTo: 'Notes To',
  replyNotes: 'Reply Notes',
  userAvatar: 'User Avatar',
  noChatRecord: 'No chat record found.',
  writeMessagePlaceholder: 'Write the message...',
  send: 'Send',
  selectCompanyPlaceholder:'Please select company'
}

export const RNDClaimApproachConstants = {
  Question1: "What do the company’s trading activities relate to? What is the company’s USP (this could be scientific/technological or other)?",
  Question2: "Does the sector in which the company is operating have to adhere to certain standards or regulations that drive the company’s R&D?",
  Question3: "Is the company a part of a wider group? Please provide brief details of the group structure and if group resources are pooled together for project work.",
  Question4: "What is the size of the company’s technical team(s) and what are the key technical disciplines within the team?",
  Question5: "Does the company employ many contractor personnel to assist with R&D project activities, or alternatively contract out the R&D?",
  Question6: "Has the company won any awards for its R&D projects undertaken in recent years?",
  Question7: "Is there any other relevant information that you would like to mention in relation to the company’s R&D?",
  Question8:"What has driven the company’s R&D projects during the claim period? ",
  Question9:"What kind of records has the company used to identify R&D projects undertaken? Tick those that apply. Use the ‘Other’ box to add in a tailored response.",
  Question16:"Please tick any or all that apply. Please use the ‘Other’ box to provide a further tailored response if any of the boxes below do not fully reflect the Contracted-Out arrangements or where you would like to add further detail to the options selected below.",
  Question18:"Name these licences below.",
  Question19:"How was the R&D eligibility assessed for these costs? Tick one of the following:",
  Question21:"Has the company claimed for general use software licences (licences that may be used for general business purposes mainly, but also for R&D)?",
  Question23:"Which projects was this data used in and for what purpose?",
  Question24:"How was the assessment of R&D eligibility undertaken?  Tick one that applies.  Please use the ‘Other’ box to provide a tailored response where necessary.",
  Question26:"Has the company claimed for overseas activities?",
  Question32:"Has the company claimed for the following:",
  Question33:"Which project activities/phase of clinical trials do these payments relate to? ",
  Question35:" Has the company previously claimed R&D Tax reliefs?",
  Question36:"Edit the text below as appropriate and (optional) give examples of ineligible project activities that have been excluded.",
  Question37:"What types of activities/projects were these licences used on?",
  Question38:"How was the assessment of R&D eligibility undertaken?  Tick one that applies.  Please use the ‘Other’ box to provide a tailored response where necessary.",
};
